'use client';

import {Heading} from '@/components/heading';
import {Body} from '@/components/body';
import AutoScroll from 'embla-carousel-auto-scroll';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import SectionHeader from '@/app/(website)/components/SectionHeader';
import {useEffect, useRef, useState} from 'react';
import {SAMPLES_APPALTI} from '@/types/samples';

const SAMPLES_LOOP = [...SAMPLES_APPALTI, ...SAMPLES_APPALTI];

export default function SamplesAppalti() {
  const [isVisible, setIsVisible] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {threshold: 0.2},
    );

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      if (contentRef.current) {
        observer.unobserve(contentRef.current);
      }
    };
  }, []);

  return (
    <div className="flex flex-col w-full items-center gap-10 py-16">
      <SectionHeader
        badgeText="COME SI USA"
        title={
          <>
            Esempi di attività per una{' '}
            <span className="rounded-[2rem] rounded-br-[8px] py-0 px-2 md:px-4 bg-secondary text-primary">
              stazione appaltante
            </span>
          </>
        }
        subtitle="Dalla ricerca alla prima bozza, fino all'analisi di allegati e documenti complessi: ecco alcuni esempi concreti di utilizzo."
        className="px-8"
      />

      <div
        className="flex flex-col gap-4 md:gap-6 relative max-w-full overflow-x-hidden"
        ref={contentRef}
      >
        <Carousel
          className={`w-full transition-all duration-1000 ease-in-out transform ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-40'
          }`}
          opts={{loop: isVisible}}
          plugins={[
            AutoScroll({
              direction: 'forward',
              speed: 0.75,
              stopOnInteraction: false,
            }),
          ]}
        >
          <CarouselContent>
            {SAMPLES_LOOP.map((s, i) => (
              <CarouselItem className="md:basis-1/2 lg:basis-1/3 flex" key={i}>
                <div className="flex-1 bg-background-4 rounded-2xl py-16 px-4 md:p-16 flex flex-col justify-between">
                  <div className="flex flex-col items-center gap-4 text-center">
                    <Heading variant="h4">{s.subject}</Heading>
                    <Body>{s.body}</Body>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
        <div className="absolute hidden md:flex inset-0 bg-gradient-to-r from-white via-transparent to-white pointer-events-none" />
      </div>
    </div>
  );
}
